module.exports = App.LoyaltyProgramsController = Em.Controller.extend
  env:                 Em.inject.service('environment')
  loyaltyEnabled:      Em.computed.alias('env.features.loyaltyProgramsEnabled')
  advertsEnabled:      Em.computed.alias('env.features.advertsEnabled')
  clientTagsEnabled:   Em.computed.alias('env.features.enableClientTagAutoassign')
  bonusCategoriesEnabled:   Em.computed.alias('env.features.bonusCategories')